/**
 * GraphPreviewBlock: `graph-preview` DYNAMIC content block.
 *
 * data: {} (no fields)
 *
 * A thin wrapper around EcosystemGraphPreview
 * (client/src/features/graph/components/EcosystemGraphPreview.jsx): the
 * compact, non-interactive network preview. It fetches its own tenant-scoped
 * graph data, so this block adds no fetching of its own.
 *
 * EcosystemGraphPreview is heavy (react-force-graph-2d), so it is lazy-loaded
 * with a Spinner fallback.
 */
import React, { Suspense, lazy } from 'react';
import { Spinner } from 'react-bootstrap';

const EcosystemGraphPreview = lazy(
    () => import('@/features/graph/components/EcosystemGraphPreview')
);

export default function GraphPreviewBlock() {
    return (
        <div className="text-center">
            <Suspense
                fallback={
                    <div className="d-flex justify-content-center py-5">
                        <Spinner
                            animation="border"
                            variant="primary"
                            role="status"
                        >
                            <span className="visually-hidden">
                                Loading graph…
                            </span>
                        </Spinner>
                    </div>
                }
            >
                <EcosystemGraphPreview height={360} />
            </Suspense>
        </div>
    );
}
